<template>
    <section class="content">
        <div class="container-fluid">

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">
                                Daftar Pelanggan Dismantle
                                <small>(Belum Bayar >= 1 Bulan)</small> Bulan {{ tanggal_tampil }}
                            </h3>


                        </div>
                        <!-- /.card-header -->
                        <v-app>
                            <v-main>
                                <div class="card-body">
                                    <ul class="nav nav-tabs custom-tabs" id="custom-content-above-tab" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link active" id="custom-content-above-home-tab"
                                                data-toggle="pill" href="#custom-content-above-home" role="tab"
                                                aria-controls="custom-content-above-home" aria-selected="true">
                                                <i class="fa fa-user-alt"></i>
                                                <span>PPPOE</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" id="custom-content-above-profile-tab" data-toggle="pill"
                                                href="#custom-content-above-profile" role="tab"
                                                aria-controls="custom-content-above-profile" aria-selected="false">
                                                <i class="fa fa-users"></i>
                                                <span>CORPORATE</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <div class="tab-custom-content"></div>
                                    <div class="tab-content" id="custom-content-above-tabContent">
                                        <div class="tab-pane fade show active" id="custom-content-above-home"
                                            role="tabpanel" aria-labelledby="custom-content-above-home-tab">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="small-box bg-primary">
                                                        <div class="inner">
                                                            <h3>{{ parseInt(jlh_data_pppoe) }}</h3>
                                                            <small>Jumlah Pelanggan Dismantle</small>
                                                        </div>
                                                        <div class="icon">
                                                            <i class="fas fa-users"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="small-box bg-primary">
                                                        <div class="inner">
                                                            <h3>{{ parseInt(ttl_data_pppoe) | toCurrency }}</h3>
                                                            <small>Total Rp Dismantle</small>
                                                        </div>
                                                        <div class="icon">
                                                            <i class="fas fa-money-bill"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <v-row class="mb-1">
                                                <v-col :md="4">
                                                    <div class="form-group mb-2">
                                                        <MonthPicker v-model="filter.periode" label="Filter Periode"
                                                            @input="onFilterChange" class="custom-input" />
                                                    </div>
                                                    <div class="form-group mb-2">
                                                        <KantorCabang v-model="filter.kantor" label="Filter Cabang"
                                                            @input="onFilterChange" class="custom-input" />
                                                    </div>

                                                </v-col>

                                                <v-col :md="4" :offset-md="4">
                                                    <TextSearch v-model="filter.search" class="custom-input"
                                                        label="Cari Nama Pelanggan" @input="onFilterChange" />
                                                </v-col>
                                            </v-row>
                                            <v-data-table :headers="headers" :items="datas" :loading="loading"
                                                :items-per-page.sync="pagination.itemsPerPage"
                                                :page.sync="pagination.page" :server-items-length="pagination.total"
                                                :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100] }" item-key="id"
                                                sort-by="no" class="elevation-1" show-group-by :search="cari_dt_plg"
                                                @update:page="loadUnpaid" @update:items-per-page="changeItemsPerPage">
                                                <!-- Header Grouping -->
                                                <template
                                                    v-slot:group.header="{ group, headers, toggle, isOpen, remove }">
                                                    <td :colspan="headers.length - 1">
                                                        <v-btn @click="toggle" x-small icon :ref="group">
                                                            <v-icon v-if="isOpen">mdi-minus</v-icon>
                                                            <v-icon v-else>mdi-plus</v-icon>
                                                        </v-btn>
                                                        <span class="mx-3">
                                                            Nama Pelanggan: <span class="font-weight-bold"> {{ group
                                                                }}</span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <v-btn @click="remove" x-small icon>
                                                            <v-icon>mdi-close</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </template>

                                                <!-- Nomor -->
                                                <template v-slot:item.no="{ item }">
                                                    {{ item.no | zerofill }}
                                                </template>

                                                <!-- Periode Invoice -->
                                                <template v-slot:item.bulan_pemakaian="{ item }">
                                                    {{ getBulan(item.bulan_pemakaian) }}
                                                </template>

                                                <!-- Total Kontrak -->
                                                <template v-slot:item.total_kontrak="{ item }">
                                                    <div class="text-right font-weight-bold">
                                                        {{ (parseInt(item.harga_paket) + parseInt(item.ppn_rp) -
                                                            parseInt(item.diskon_rp)) | toCurrency }}
                                                    </div>
                                                </template>

                                                <!-- Total Bayar -->
                                                <template v-slot:item.total_bayar="{ item }">
                                                    <div class="text-right font-weight-bold">
                                                        {{ item.total_bayar | toCurrency }}
                                                    </div>
                                                </template>

                                                <!-- Actions -->
                                                <template v-slot:item.actions="{ item }">
                                                    <div class="tanpawrap">
                                                        <a v-if="item.url_bukti && item.url_bukti !== ''"
                                                            class="btn btn-xs btn-primary" :href="'./' + item.url_bukti"
                                                            target="_blank" title="Download Bukti">
                                                            <i class="fas fa-download text-white"></i>
                                                        </a>

                                                        <button class="btn btn-xs btn-warning"
                                                            @click="printInvoice(item)" title="Lihat Invoice">
                                                            <i class="fa fa-file text-white"></i>
                                                        </button>
                                                        <button :disabled="item.pelanggan_internet.is_active != 1"
                                                            class="btn btn-xs btn-danger"
                                                            @click="nonAktifkan(item.pelanggan_internet.id)"
                                                            title="Non-Aktifkan">
                                                            <i class="fa fa-power-off"></i> Non-Aktif
                                                        </button>
                                                        <button class="btn btn-xs btn-secondary"
                                                            @click="bukaModalCabutModem(item)" title="Cabut Modem">
                                                            <i class="fa fa-plug"></i> Cabut Modem
                                                        </button>


                                                    </div>

                                                </template>

                                                <!-- No Data Message -->
                                                <template v-slot:no-data>
                                                    <h6>Data Tidak Ditemukan</h6>
                                                </template>
                                            </v-data-table>
                                        </div>

                                        <div class="tab-pane fade" id="custom-content-above-profile" role="tabpanel"
                                            aria-labelledby="custom-content-above-profile-tab">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="small-box bg-primary">
                                                        <div class="inner">
                                                            <h3>{{ parseInt(jlh_data_corpo) }}</h3>
                                                            <small>Jumlah Pelanggan Dismantle</small>
                                                        </div>
                                                        <div class="icon">
                                                            <i class="fas fa-users"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="small-box bg-primary">
                                                        <div class="inner">
                                                            <h3>{{ parseInt(ttl_data_corpo) | toCurrency }}</h3>
                                                            <small>Total Rp Dismantle</small>
                                                        </div>
                                                        <div class="icon">
                                                            <i class="fas fa-money-bill"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <v-row class="mb-1">
                                                <v-col :md="4">
                                                    <v-select v-model="filter_corp" :items="filter_plg" item-text="text"
                                                        item-value="id" label="Pilih Filter" outlined dense
                                                        return-object class="w-100">
                                                    </v-select>
                                                </v-col>
                                                <v-col :md="4" :offset-md="4">
                                                    <v-text-field v-model="cari_dt_plg_corp" label="Cari"
                                                        class="w-100 col-md-5 ml-auto mb-2" outlined dense hide-details>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-data-table @update:group-desc="tableGrouping" :headers="headers_corp"
                                                :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100, -1] }"
                                                :items="datas_corp" :items-per-page="25" item-key="id" sort-by="no"
                                                class="elevation-1" show-group-by :search="cari_dt_plg_corp">
                                                <!-- Header Grouping -->
                                                <template
                                                    v-slot:group.header="{ group, headers, toggle, isOpen, remove }">
                                                    <td :colspan="headers.length - 1">
                                                        <v-btn @click="toggle" x-small icon :ref="group">
                                                            <v-icon v-if="isOpen">mdi-minus</v-icon>
                                                            <v-icon v-else>mdi-plus</v-icon>
                                                        </v-btn>
                                                        <span class="mx-3">
                                                            Nama Pelanggan: <span class="font-weight-bold">{{ group
                                                                }}</span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <v-btn @click="remove" x-small icon>
                                                            <v-icon>mdi-close</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </template>

                                                <!-- Nomor -->
                                                <template v-slot:item.no="{ item }">
                                                    {{ item.no | zerofill }}
                                                </template>

                                                <!-- Periode Invoice -->
                                                <template v-slot:item.bulan_pemakaian="{ item }">
                                                    {{ getBulan(item.bulan_pemakaian) }}
                                                </template>

                                                <!-- Total Kontrak -->
                                                <template v-slot:item.total_kontrak="{ item }">
                                                    <div class="text-right font-weight-bold">
                                                        {{ item.total_kontrak | toCurrency }}
                                                    </div>
                                                </template>

                                                <!-- Total Bayar -->
                                                <template v-slot:item.total_bayar="{ item }">
                                                    <div class="text-right font-weight-bold">
                                                        {{ item.total_bayar | toCurrency }}
                                                    </div>
                                                </template>

                                                <!-- Actions -->
                                                <template v-slot:item.actions="{ item }">
                                                    <div class="tanpawrap">
                                                        <a v-if="item.url_bukti && item.url_bukti !== ''"
                                                            class="btn btn-xs btn-primary" :href="'./' + item.url_bukti"
                                                            target="_blank" title="Download Bukti">
                                                            <i class="fas fa-download text-white"></i>
                                                        </a>
                                                        <button class="btn btn-xs btn-warning"
                                                            @click="printInvoice(item)" title="Lihat Invoice">
                                                            <i class="fa fa-file text-white"></i>
                                                        </button>
                                                        <button :disabled="item.pelanggan_internet.is_active != 1" 
                                                            class="btn btn-xs btn-danger"
                                                            @click="nonAktifkan(item.pelanggan_internet.id)"
                                                            title="Non-Aktifkan">
                                                            <i class="fa fa-power-off"></i> Non-Aktif
                                                        </button>
                                                        <button class="btn btn-xs btn-secondary"
                                                            @click="bukaModalCabutModem(item)" title="Cabut Modem">
                                                            <i class="fa fa-plug"></i> Cabut Modem
                                                        </button>
                                                        <button class="btn btn-xs btn-info" @click="bukaModal(item)"
                                                            title="Edit Data">
                                                            <i class="fa fa-edit"></i>
                                                        </button>
                                                    </div>
                                                </template>

                                                <!-- No Data Message -->
                                                <template v-slot:no-data>
                                                    <h6>Data Tidak Ditemukan</h6>
                                                </template>
                                            </v-data-table>
                                        </div>
                                    </div>
                                </div>
                            </v-main>
                        </v-app>
                        <div class="card-footer"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade " id="modalEdit" tabindex="-1" role="dialog" aria-labelledby="modalEdit"
            aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit Data Invoice</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <form @submit.prevent="updateInvoice()" enctype="multipart/form-data" id="formnya">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card card-outline card-primary">
                                        <div class="card-header">
                                            <h3 class="card-title" style="margin:0px">Data Pelanggan</h3>
                                        </div>
                                        <div class="card-body">
                                            <input type="hidden" v-model="form.invoice.id" name="invoice.id">
                                            <div class="row">
                                                <!-- Username Field -->
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Username</label>
                                                        <input type="text" v-model="form.invoice.username"
                                                            name="invoice.username" class="form-control"
                                                            :class="{ 'is-invalid': adaeror['invoice.username'] }"
                                                            readonly />
                                                        <small v-if="adaeror['invoice.username']" class="text-danger">
                                                            {{ adaeror["invoice.username"].join(', ') }}
                                                        </small>
                                                    </div>
                                                </div>

                                                <!-- Nama Field -->
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Nama</label>
                                                        <input type="text" v-model="form.invoice.nama"
                                                            name="invoice.nama" class="form-control"
                                                            :class="{ 'is-invalid': adaeror['invoice.nama'] }"
                                                            readonly />
                                                        <small v-if="adaeror['invoice.nama']" class="text-danger">
                                                            {{ adaeror["invoice.nama"].join(', ') }}
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="row">
                                                <!-- Nama Tempat Instalasi Field -->
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Nama Tempat Instalasi</label>
                                                        <input type="text" v-model="form.invoice.nama_tempat"
                                                            name="invoice.nama_tempat" class="form-control"
                                                            :class="{ 'is-invalid': adaeror['invoice.nama_tempat'] }"
                                                            readonly />
                                                        <small v-if="adaeror['invoice.nama_tempat']"
                                                            class="text-danger">
                                                            {{ adaeror["invoice.nama_tempat"].join(', ') }}
                                                        </small>
                                                    </div>
                                                </div>

                                                <!-- Paket Field -->
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Paket</label>
                                                        <input type="text" v-model="form.invoice.paket"
                                                            name="invoice.paket" class="form-control"
                                                            :class="{ 'is-invalid': adaeror['invoice.paket'] }"
                                                            readonly />
                                                        <small v-if="adaeror['invoice.paket']" class="text-danger">
                                                            {{ adaeror["invoice.paket"].join(', ') }}
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>


                                            <hr style="border:1px solid;" />
                                            <h5>Data Billing</h5>
                                            <div class="row">
                                                <!-- Harga Paket -->
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label>Harga Paket</label>
                                                        <input type="text" v-model="form.invoice.harga_paket"
                                                            name="invoice.harga_paket" class="form-control"
                                                            :class="{ 'is-invalid': adaeror['invoice.harga_paket'] }"
                                                            readonly />
                                                        <small v-if="adaeror['invoice.harga_paket']"
                                                            class="text-danger">
                                                            {{ adaeror["invoice.harga_paket"].join(', ') }}
                                                        </small>
                                                    </div>
                                                </div>

                                                <!-- PPN -->
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label>
                                                            PPN
                                                            <span class="ml-1">
                                                                (Print?
                                                                <input type="checkbox"
                                                                    v-model="form.invoice.print_pajak"
                                                                    name="print_pajak" />)
                                                            </span>
                                                        </label>
                                                        <input type="text" v-model="form.invoice.ppn" name="invoice.ppn"
                                                            class="form-control"
                                                            :class="{ 'is-invalid': adaeror['invoice.ppn'] }"
                                                            readonly />
                                                        <small v-if="adaeror['invoice.ppn']" class="text-danger">
                                                            {{ adaeror["invoice.ppn"].join(', ') }}
                                                        </small>
                                                    </div>
                                                </div>

                                                <!-- Diskon Pengguna -->
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label>Diskon Pengguna</label>
                                                        <input type="text" v-model="form.invoice.diskon"
                                                            name="invoice.diskon" class="form-control"
                                                            :class="{ 'is-invalid': adaeror['invoice.diskon'] }"
                                                            readonly />
                                                        <small v-if="adaeror['invoice.diskon']" class="text-danger">
                                                            {{ adaeror["invoice.diskon"].join(', ') }}
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row" v-show="tipe_pelanggan_edit == '2'">
                                                <!-- Tanggal Terbit Invoice -->
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label>Tanggal Terbit Invoice</label>
                                                        <v-menu v-model="menu" :close-on-content-click="false"
                                                            :nudge-right="40" transition="scale-transition" offset-y
                                                            min-width="auto">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-text-field class="mt-0 pt-0"
                                                                    v-model="form.invoice.tanggal" label=""
                                                                    prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                                    v-on="on"></v-text-field>
                                                            </template>
                                                            <v-date-picker v-model="form.invoice.tanggal"
                                                                @input="menu = false"></v-date-picker>
                                                        </v-menu>
                                                        <small v-if="adaeror['invoice.tanggal']" class="text-danger">
                                                            {{ adaeror["invoice.tanggal"].join(', ') }}
                                                        </small>
                                                    </div>
                                                </div>

                                                <!-- Tanggal Batas Bayar -->
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label>Tanggal Batas Bayar</label>
                                                        <v-menu v-model="menu2" :close-on-content-click="false"
                                                            :nudge-right="40" transition="scale-transition" offset-y
                                                            min-width="auto">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-text-field class="mt-0 pt-0"
                                                                    v-model="form.invoice.tanggal_batas_bayar" label=""
                                                                    prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                                    v-on="on"></v-text-field>
                                                            </template>
                                                            <v-date-picker v-model="form.invoice.tanggal_batas_bayar"
                                                                @input="menu2 = false"></v-date-picker>
                                                        </v-menu>
                                                        <small v-if="adaeror['invoice.tanggal_batas_bayar']"
                                                            class="text-danger">
                                                            {{ adaeror["invoice.tanggal_batas_bayar"].join(', ') }}
                                                        </small>
                                                    </div>
                                                </div>

                                                <!-- Cashback -->
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label>Cashback</label>
                                                        <input type="number" v-model="form.invoice.kickback"
                                                            name="kickback" class="form-control"
                                                            :class="{ 'is-invalid': adaeror['kickback'] }" readonly
                                                            @keydown="preventArrow($event)" />
                                                        <small v-if="adaeror['kickback']" class="text-danger">
                                                            {{ adaeror["kickback"].join(', ') }}
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <!-- PPN Keluaran -->
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label>PPN KELUARAN (Rp.)</label>
                                                        <input type="number" v-model="form.invoice.ppn_keluaran"
                                                            name="ppn_keluaran" class="form-control"
                                                            :class="{ 'is-invalid': adaeror['total_potongan'] }"
                                                            readonly @keydown="preventArrow($event)" />
                                                        <small v-if="adaeror['total_potongan']" class="text-danger">
                                                            {{ adaeror["total_potongan"].join(', ') }}
                                                        </small>
                                                    </div>
                                                </div>

                                                <!-- PPH 23 -->
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label>PPH 23 (Rp.)</label>
                                                        <input type="number" v-model="form.invoice.pph23" name="pph23"
                                                            class="form-control"
                                                            :class="{ 'is-invalid': adaeror['total_potongan'] }"
                                                            readonly @keydown="preventArrow($event)" />
                                                        <small v-if="adaeror['total_potongan']" class="text-danger">
                                                            {{ adaeror["total_potongan"].join(', ') }}
                                                        </small>
                                                    </div>
                                                </div>

                                                <!-- Zakat -->
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label>Zakat (Rp.)</label>
                                                        <input type="number" v-model="form.invoice.zakat" name="zakat"
                                                            class="form-control"
                                                            :class="{ 'is-invalid': adaeror['total_potongan'] }"
                                                            readonly />
                                                        <small v-if="adaeror['total_potongan']" class="text-danger">
                                                            {{ adaeror["total_potongan"].join(', ') }}
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <!-- Tagihan Pemakaian -->
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label>Tagihan Pemakaian</label>
                                                        <input type="text" v-model="form.invoice.tagihan"
                                                            name="invoice.tagihan" class="form-control"
                                                            :class="{ 'is-invalid': adaeror['invoice.tagihan'] }"
                                                            readonly />
                                                        <small v-if="adaeror['invoice.tagihan']" class="text-danger">
                                                            {{ adaeror["invoice.tagihan"].join(', ') }}
                                                        </small>
                                                    </div>
                                                </div>

                                                <!-- Total Bayar -->
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label>Total Bayar</label>
                                                        <input type="number" v-model="form.invoice.total_bayar"
                                                            name="invoice.total_bayar" class="form-control"
                                                            :class="{ 'is-invalid': adaeror['invoice.total_bayar'] }"
                                                            readonly @keydown="preventArrow($event)" />
                                                        <small v-if="adaeror['invoice.total_bayar']"
                                                            class="text-danger">
                                                            {{ adaeror["invoice.total_bayar"].join(', ') }}
                                                        </small>
                                                    </div>
                                                </div>

                                                <!-- Status Pembayaran -->
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label>Status</label>
                                                        <select class="form-control is-warning"
                                                            v-model="form.invoice.status_bayar"
                                                            name="invoice.status_bayar" disabled>
                                                            <option :value="0">Unpaid</option>
                                                            <option :value="1">Paid</option>
                                                        </select>
                                                        <small v-if="adaeror['invoice.status_bayar']"
                                                            class="text-danger">
                                                            {{ adaeror["invoice.status_bayar"].join(', ') }}
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Simpan</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- Modal Cabut Modem -->
        <div class="modal fade " id="modalCabutModem" tabindex="-1" role="dialog" aria-labelledby="modalCabutModem"
            aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Cabut Modem</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <form @submit.prevent="submitCabutModem" enctype="multipart/form-data">
                        <div class="modal-body">
                            <div class="form-group">
                                <label>Nomor Seri Modem</label>
                                <input type="text" v-model="formCabutModem.nomor_seri_modem" class="form-control"
                                    required />
                            </div>
                            <div class="form-group">
                                <label>Merek Modem (Opsional)</label>
                                <input type="text" v-model="formCabutModem.merek_modem" class="form-control" 
                                    placeholder="Kosongkan jika nomor seri sudah ada di inventory" />
                            </div>
                            <div class="form-group">
                                <label>Foto Modem (Opsional)</label>
                                <input type="file" ref="foto_modem" class="form-control" accept="image/*"
                                    @change="onFotoModemChange" />
                            </div>
                            <div class="form-group">
                                <label>Tanggal Pencabutan</label>
                                <input type="date" v-model="formCabutModem.tanggal_pencabutan" class="form-control"
                                    required />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary" :disabled="modalCabutModemLoading">
                                <span v-if="modalCabutModemLoading" class="spinner-border spinner-border-sm"></span>
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import MonthPicker from '../../base-components/MonthPicker.vue'
import KantorCabang from '../../base-components/KantorCabang.vue'
import TextSearch from '../../base-components/TextSearch.vue';
export default {
    components: {
        MonthPicker,
        KantorCabang,
        TextSearch
    },
    data() {
        return {
            filter: {
                periode: new Date().toISOString().slice(0, 7),
                kantor: null,
                search: null,
            },
            dateMax: new Date().toISOString().substr(0, 7),
            tanggal_query: new Date().toISOString().substr(0, 7),
            tanggal_tampil: '',
            filter_corp: "0",
            filter_pppoe: "0",
            filter_plg: [
                { text: 'Semua', id: '0' },
                { text: 'Harga Full', id: '1' },
                { text: 'Harga Prorate', id: '2' },
            ],
            jlh_data_pppoe: '0',
            ttl_data_pppoe: '0',
            jlh_data_corpo: '0',
            ttl_data_corpo: '0',
            jlh_invoice: '0',
            ttl_invoice: '0',
            cari_dt_plg_corp: '',
            cari_dt_plg: '',
            checkbox: false,
            datas_corp: [],
            datas: [],
            form: new Form({
                invoice: {
                    id: '',
                    username: '',
                    nama: '',
                    nama_tempat: '',
                    paket: '',
                    harga_paket: '',
                    diskon: '',
                    ppn: '',
                    tagihan: '',
                    tanggal: '',
                    tanggal_batas_bayar: '',
                    total_bayar: '0',
                    total: '0',
                    status_bayar: '0',
                    print_pajak: '0',
                    print_diskon: '0',
                    kickback: '0',
                    ppn_keluaran: '0',
                    pph23: '0',
                    zakat: '0',
                    downtime: '0',
                    downtime_rp: '0',
                    keterangan: '',
                    kantor_id: '',
                }
            }),
            formCabutModem: {
                id_pelanggan: '',
                nomor_seri_modem: '',
                merek_modem: '',
                foto_modem: null,
                tanggal_pencabutan: new Date().toISOString().slice(0, 10),
            },
            modalCabutModemLoading: false,
            modaltgl: false,
            menu2: false,
            menu: false,
            tipe_pelanggan_edit: '0',
            adaeror: [],
            loading: false,
            pagination: {
                page: 1,
                itemsPerPage: 25,
                total: 0,
            },
        }
    },

    computed: {
        headers() {
            return [
                { text: 'ID Pelanggan', value: 'pelanggan_internet.id', groupable: false, sortable: false, minWidth: '100px' },
                { text: 'No Inv', value: 'id', groupable: false, },
                { text: 'Tempat Instalasi', value: 'pelanggan_internet.nama', groupable: false, },
                { text: 'Periode Invoice', value: 'bulan_pemakaian', groupable: false, },
                {
                    text: 'Tipe Invoice', value: 'tipe_invoice_val', groupable: false, sortable: false, align: " d-none", filter: value => {
                        if (this.filter_pppoe.id == 1) {
                            return value === "Penuh";
                        } else if (this.filter_pppoe.id == 2) {
                            return value === "Prorate";
                        } else {
                            return true;
                        }
                    },
                },
                { text: 'Rp Kontrak', value: 'total_kontrak', groupable: false, },
                { text: 'Rp BAYAR', value: 'total_bayar', groupable: false, align: "end", class: "text-right" },
                { text: 'Tanggal Bayar', value: 'tanggal_bayar', groupable: false, align: "end", class: "text-right" },
                { text: 'Aksi', value: 'actions', sortable: false, groupable: false, align: "center", class: "text-center" },
            ]
        },

        headers_corp() {
            return [
                { text: 'ID Pelanggan', value: 'pelanggan_internet.id', groupable: false, sortable: false, minWidth: '100px' },
                { text: 'No Inv', value: 'id', groupable: false, },
                { text: 'Tempat Instalasi', value: 'pelanggan_internet.nama', groupable: false, },
                { text: 'Periode Invoice', value: 'bulan_pemakaian', groupable: false, },
                {
                    text: 'Tipe Invoice', value: 'tipe_invoice_val', groupable: false, sortable: false, align: " d-none", filter: value => {
                        if (this.filter_corp.id == 1) {
                            return value === "Penuh";
                        } else if (this.filter_corp.id == 2) {
                            return value === "Prorate";
                        } else {
                            return true;
                        }
                    },
                },
                { text: 'Rp Kontrak', value: 'total_kontrak', groupable: false, },
                { text: 'Rp BAYAR', value: 'total_bayar', groupable: false, align: "end", class: "text-right" },
                { text: 'Tanggal Bayar', value: 'tanggal_bayar', groupable: false, align: "end", class: "text-right" },
                { text: 'Aksi', value: 'actions', sortable: false, groupable: false, align: "center", class: "text-center" },
            ]
        },
    },

    methods: {
        onFilterChange() {
            this.pagination.page = 1;
            this.loadUnpaid();
        },
        changeItemsPerPage(val) {
            this.pagination.itemsPerPage = val;
            this.pagination.page = 1;
            this.loadUnpaid();
        },
        ubahTanggalTampil(e) {
            e.dialog.save(this.tanggal_query);
            this.loadUnpaid();
        },

        downloadFile(response, filename) {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([response.data], { type: 'application/pdf' });

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob);
                return
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            link.href = data;
            link.download = filename + '.pdf'
            document.body.appendChild(link);
            link.click();
            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
            }, 100)
        },

        printInvoice(item) {
            this.$Progress.start();
            let namaFileDownload = "Invoice " + item.pelanggan_internet.nama + " " + item.bulan_pemakaian;
            axios.get('api/invoice/printpdf?id_invoice=' + item.id, { responseType: 'blob' }).then(response => {
                this.downloadFile(response, namaFileDownload);
                this.$Progress.finish();
            }, response => {
                Toast.fire({
                    icon: 'error',
                    title: data.data.data ? data.data.data : "Error!. Download Invoice Gagal."
                });
                this.$Progress.fail();
            });
        },

        preventArrow(e) {
            if (e.which === 38 || e.which === 40) {
                e.preventDefault();
            }
            if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57) {
                e.preventDefault();
            }
        },

        bukaModalCabutModem(item) {
            this.formCabutModem.id_pelanggan = item.pelanggan_internet.id;
            this.formCabutModem.nomor_seri_modem = '';
            this.formCabutModem.merek_modem = '';
            this.formCabutModem.foto_modem = null;
            this.formCabutModem.tanggal_pencabutan = new Date().toISOString().slice(0, 10);
            if (this.$refs.foto_modem) {
                this.$refs.foto_modem.value = null;
            }
            $('#modalCabutModem').modal('show');
        },

        onFotoModemChange(e) {
            this.formCabutModem.foto_modem = e.target.files[0];
        },

        submitCabutModem() {
            this.modalCabutModemLoading = true;
            let formData = new FormData();
            formData.append('id_pelanggan', this.formCabutModem.id_pelanggan);
            formData.append('nomor_seri_modem', this.formCabutModem.nomor_seri_modem);
            if (this.formCabutModem.merek_modem) {
                formData.append('merek_modem', this.formCabutModem.merek_modem);
            }
            formData.append('tanggal_pencabutan', this.formCabutModem.tanggal_pencabutan);
            if (this.formCabutModem.foto_modem) {
                formData.append('foto_modem', this.formCabutModem.foto_modem);
            }

            axios.post('api/invoice/dismantle_cabut_modem', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                this.modalCabutModemLoading = false;
                $('#modalCabutModem').modal('hide');
                Toast.fire({
                    icon: 'success',
                    title: 'Berhasil melakukan Cabut Modem'
                });
                this.loadUnpaid();
            }).catch(error => {
                this.modalCabutModemLoading = false;
                Toast.fire({
                    icon: 'error',
                    title: error.response?.data?.message || 'Gagal Cabut Modem'
                });
            });
        },

        nonAktifkan(id_pelanggan) {
            Swal.fire({
                title: 'Apakah Anda Yakin?',
                text: "Pelanggan ini akan dinonaktifkan!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, Non-Aktifkan!'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post('api/pppoe/nonaktifkan/' + id_pelanggan)
                        .then(() => {
                            Toast.fire({
                                icon: 'success',
                                title: 'Berhasil Menonaktifkan Pelanggan'
                            });
                            this.loadUnpaid();
                        })
                        .catch(() => {
                            Toast.fire({
                                icon: 'error',
                                title: 'Gagal Menonaktifkan Pelanggan'
                            });
                        });
                }
            })
        },

        updateInvoice() {
            this.$Progress.start();
            Swal.fire({
                title: 'Are you sure?',
                text: "Apakah Anda Yakin Untuk Mengupdate Data Invoice pelanggan?",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes!'
            }).then((result) => {
                if (result.value) {
                    let editFormData = new FormData();
                    let dataUpdate = {};
                    dataUpdate['id'] = this.form.invoice.id;
                    dataUpdate['tanggal'] = this.form.invoice.tanggal;
                    dataUpdate['tanggal_batas_bayar'] = this.form.invoice.tanggal_batas_bayar;
                    dataUpdate['total_bayar'] = this.form.invoice.total_bayar;
                    dataUpdate['status_bayar'] = this.form.invoice.status_bayar;
                    dataUpdate['print_pajak'] = this.form.invoice.print_pajak;
                    dataUpdate['print_diskon'] = this.form.invoice.print_diskon;
                    dataUpdate['kickback'] = this.form.invoice.kickback;
                    dataUpdate['total'] = this.form.invoice.total;
                    dataUpdate['zakat'] = this.form.invoice.zakat;
                    dataUpdate['pph23'] = this.form.invoice.pph23;
                    dataUpdate['ppn_keluaran'] = this.form.invoice.ppn_keluaran;
                    dataUpdate['downtime'] = this.form.invoice.downtime;
                    dataUpdate['downtime_rp'] = this.form.invoice.downtime_rp;
                    dataUpdate['keterangan'] = this.form.invoice.keterangan;
                    dataUpdate['kantor_id'] = this.form.invoice.kantor_id;

                    editFormData.append('datanya', JSON.stringify(dataUpdate));
                    axios.post('api/invoice/edit_invoice_paid', editFormData).then((data) => {
                        console.log(data);
                        if (data.data.success) {

                            Toast.fire({
                                icon: 'success',
                                title: data.data.message
                            });
                            this.$Progress.finish();
                            this.loadUnpaid();
                            $('#modalEdit').modal('hide');
                        } else {
                            Toast.fire({
                                icon: 'error',
                                title: data.data.data ? data.data.data : "Error!. Try again later."
                            });

                            this.$Progress.fail();
                        }
                    })
                        .catch(e => {
                            Toast.fire({
                                icon: 'error',
                                title: data.data.data ? data.data.data : "Error!."
                            });
                            this.$Progress.fail();
                        });
                }
            })
        },

        bukaModal(item) {
            this.adaeror = [];
            this.form.reset();
            this.tipe_pelanggan_edit = item.pelanggan_internet.tipe_langganan;
            this.form.invoice.id = item.id;
            this.form.invoice.username = item.pelanggan_internet.username;
            this.form.invoice.nama = item.pelanggan_internet.pelanggan.nama;
            this.form.invoice.nama_tempat = item.pelanggan_internet.nama;
            this.form.invoice.paket = item.nama_paket;
            this.form.invoice.harga_paket = item.harga_paket;
            this.form.invoice.diskon = item.diskon;
            this.form.invoice.tanggal_batas_bayar = item.tanggal_batas_bayar;
            this.form.invoice.tanggal = item.tanggal;
            this.form.invoice.ppn = item.ppn;
            this.form.invoice.tagihan = this.getBulan(item.bulan_pemakaian);
            this.form.invoice.total_bayar = item.total_bayar;
            this.form.invoice.total = item.total;
            this.form.invoice.status_bayar = '1';
            this.form.invoice.print_pajak = item.print_pajak;
            this.form.invoice.print_diskon = item.print_diskon;
            this.form.invoice.kickback = item.kickback ? item.kickback : 0;
            this.form.invoice.pph23 = item.pph23 ? item.pph23 : 0;
            this.form.invoice.ppn_keluaran = item.ppn_keluaran ? item.ppn_keluaran : 0;
            this.form.invoice.zakat = item.zakat ? item.zakat : 0;
            this.form.invoice.downtime = item.downtime ? item.downtime : 0;
            this.form.invoice.downtime_rp = item.downtime_rp ? item.downtime_rp : 0;
            this.form.invoice.keterangan = item.keterangan;
            this.form.invoice.kantor_id = item.pelanggan_internet.kantor_id;
            $('#modalEdit').modal('show');
        },

        tableGrouping(e) {
            if (e.length) {
                this.table_group_state = true;
            } else {
                this.table_group_state = false;
            }
        },
        async loadUnpaid() {
            this.loading = true;
            try {
                if (this.$gate.isAllowed("is_invoice")) {

                    if (this.$gate.dataType('1')) {
                        const bulan = this.filter.periode;
                        const res = await axios.get('api/invoice/list_dismantle?tipe=1', {
                            params: {
                                page: this.pagination.page,
                                per_page: this.pagination.itemsPerPage,
                                search: this.filter.search,
                                periode: bulan,
                                kantor_id: this.filter.kantor?.id || null
                            }
                        });

                        this.datas = res.data.data.data;
                        this.pagination.total = res.data.data.total;

                        const resTotal = await axios.get('api/invoice/list_dismantle_count?tipe=1', {
                            params: {
                                periode: bulan,
                                kantor_id: this.filter.kantor?.id || null
                            }
                        });
                        this.jlh_data_pppoe = parseInt(resTotal.data.data[0].jumlah ? resTotal.data.data[0].jumlah : 0);
                        this.ttl_data_pppoe = parseInt(resTotal.data.data[0].total ? resTotal.data.data[0].total : 0);

                    }

                }
            } catch (error) {
                console.error('Gagal memuat data:', error);
            } finally {
                this.loading = false;
            }

        },

        // loadUnpaid() {
        //     let tahunpaid = this.tanggal_query.substr(0, 4);
        //     let bulanpaid = this.tanggal_query.substr(-2, 2);
        //     if (this.$gate.isAllowed("is_invoice")) {

        //         if (this.$gate.dataType('1')) {
        //             axios.get("api/invoice/list_dismantle?tipe=1&tahunpaid=" + tahunpaid + "&bulanpaid=" + bulanpaid).then(({ data }) => (this.datas = data.data));
        //             axios.get("api/invoice/list_dismantle_count?tipe=1&tahunpaid=" + tahunpaid + "&bulanpaid=" + bulanpaid).then(({ data }) => {
        //                 this.jlh_data_pppoe = parseInt(data.data[0].jumlah ? data.data[0].jumlah : 0);
        //                 this.ttl_data_pppoe = parseInt(data.data[0].total ? data.data[0].total : 0);
        //             });
        //         }
        //         if (this.$gate.dataType('2')) {
        //             axios.get("api/invoice/list_dismantle?tipe=2&tahunpaid=" + tahunpaid + "&bulanpaid=" + bulanpaid).then(({ data }) => (this.datas_corp = data.data));
        //             axios.get("api/invoice/list_dismantle_count?tipe=2&tahunpaid=" + tahunpaid + "&bulanpaid=" + bulanpaid).then(({ data }) => {
        //                 this.jlh_data_corpo = parseInt(data.data[0].jumlah ? data.data[0].jumlah : 0);
        //                 this.ttl_data_corpo = parseInt(data.data[0].total ? data.data[0].total : 0);
        //             });
        //         }
        //     }
        //     this.tanggal_tampil = this.getBulan(this.tanggal_query);
        // },

        getBulan(tanggal) {
            var tgltemp = new Date(tanggal);
            var tahun = tgltemp.getFullYear();
            var bulan = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

            return (bulan[tgltemp.getMonth()] + " " + tahun);
        },
    },

    mounted() { },

    created() {
        this.$Progress.start();
        this.loadUnpaid();
        this.$Progress.finish();
    },
}

</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.tanpawrap {
    white-space: nowrap;
}
</style>